"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChainEqual = void 0;
function isChainEqual(c1, c2) {
    const c1Name = typeof c1 === "string" ? c1 : c1.id;
    const c2Name = typeof c2 === "string" ? c2 : c2.id;
    return c1Name.toLowerCase() === c2Name.toLowerCase();
}
exports.isChainEqual = isChainEqual;
